import React from 'react';
import styled from 'styled-components';
import PT from 'prop-types';
import { Box, Typography, Flex } from '@procore/core-react';
import ProcoreLogo from '@/react/components/ProcoreLogo';
import MobileLogo from '@/react/components/ProcoreLogo/MobileLogo';
import { FedrampLogo } from '@/react/components/ProcoreLogo/FedrampLogo';
import { UnstyledLink } from '@/react/styles';
import cx from 'classnames';

const StyledLogo = styled(Box)`
  width: 100%;
`;

const BrandingHeader = ({ isDesktop, title, marketplaceBasePath }) => {
  const DesktopLogo = window.IS_FEDRAMP ? FedrampLogo : ProcoreLogo;

  return (
    <UnstyledLink href={marketplaceBasePath}>
      <StyledLogo
        display="inline-flex"
        gap="md"
        alignItems="center"
        data-testid="procore-logo"
      >
        {isDesktop ? <DesktopLogo /> : <MobileLogo />}
        <Flex alignSelf="flex-start">
          <Typography
            weight="semibold"
            className={cx({
              'font-size-h1': isDesktop,
              'font-size-h2': !isDesktop,
              fedramp: isDesktop && window.IS_FEDRAMP,
            })}
          >
            {title}
          </Typography>
        </Flex>
      </StyledLogo>
    </UnstyledLink>
  );
};

BrandingHeader.propTypes = {
  isDesktop: PT.bool.isRequired,
  marketplaceBasePath: PT.string.isRequired,
  title: PT.string.isRequired,
};

export default BrandingHeader;
